import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.66796 5.39055C2.27743 5.00003 1.64427 5.00003 1.25374 5.39055C0.863215 5.78108 0.863216 6.41424 1.25374 6.80476L5.17264 10.7236C5.2635 10.8145 5.36749 10.8842 5.4785 10.9328C5.84478 11.0934 6.28767 11.0238 6.58752 10.7239L13.2538 4.05767C13.6444 3.66715 13.6444 3.03399 13.2538 2.64346C12.8633 2.25294 12.2301 2.25294 11.8396 2.64346L5.88022 8.60279L2.66796 5.39055Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }